<template>
  <div class="index-container">
    <el-row>
      <el-col :span="24">
        <el-row class="tcf-row" style="padding-bottom: 0;">
          <el-col :span="14" class="card">
            <div class="card-body" v-loading="todoLoading">
              <div class="card-title">
                待办事项 <el-badge :value="todoCount" :hidden="todoCount<=0" />
                <div class="right" style="padding-right: 44px">
                  <el-button type="text" style="position: absolute;right: 0;top:0;" size="small" @click="refTodo" icon="el-icon-refresh-left">刷新</el-button>
                  <el-pagination
                    v-if="todoCount>5"
                    @current-change="todoHandleCurrentChange"
                    :current-page="todoCurrentPage"
                    :page-size="todoPageSize"
                    layout="prev, next"
                    :total="todoCount">
                  </el-pagination>
                </div>
              </div>
              <div class="card-content" :style="todoData.length==0?'text-align:center;line-height:230px;':''">
                <ul class="todo-list" v-if="todoData.length>0&&todoLoading===false">
                  <li v-for="todo in todoData" @click="goTodo(todo)">
                    <i :class="todo.mark==0?'el-icon-bell':todo.mark==1?'el-icon-time todo-warning':'el-icon-warning todo-danger'"></i>
                    <div :class="todo.mark==0?'todo-name':todo.mark==1?'todo-name todo-warning':'todo-name todo-danger'">
                      {{todo.name}}
                    </div>
                    <div class="todo-time">
                      {{todo.type===23?todo.id.split('@elichain@')[1]:todo.time}}
                    </div>
                  </li>
                </ul>
                <div v-if="todoData.length<=0&&todoLoading===false" class="el-icon-document-copy" style="color: #cbe2fc;min-height: 100px;min-width:150px; font-size:5rem;" />
              </div>
            </div>
          </el-col>
          <!-- <el-col :span="12" class="card">
            <div class="card-body" v-loading="toLearnLoading">
              <div class="card-title">
                待完成学习 <el-badge v-if="toLearnCount>0" :value="toLearnCount" :hidden="toLearnBadge" />
                <el-button type="text" class="right" v-if="toLearnCount>5">更多</el-button>
              </div>
              <div class="card-content" :style="toLearnCount==0?'text-align:center;line-height:230px;':''">
                <ul class="tolearn-list" v-if="toLearnCount>0">
                  <li v-for="toLearn in toLearnData" :id="toLearn.stid">
                    <i :class="toLearn.isOverdue==0?'el-icon-edit-outline':toLearn.isOverdue==1?'el-icon-time tolearn-warning':'el-icon-warning tolearn-danger'"></i>
                    <el-progress  type="circle" :color="toLearn.isOverdue==0?'#409EFF':toLearn.isOverdue==1?'#F4BF40':'#F56C6C'" :percentage="toLearn.percent" :width="40"></el-progress>
                    <div :class="toLearn.isOverdue==0?'tolearn-name':toLearn.isOverdue==1?'tolearn-name tolearn-warning':'tolearn-name tolearn-danger'">
                      {{toLearn.st_name}}
                    </div>
                    <div class="tolearn-time">
                      截止日期：{{toLearn.endtime}}
                    </div>
                  </li>
                </ul>
                <div v-if="toLearnData.length==0" class="el-icon-document-copy" style="color: #cbe2fc;min-height: 100px;min-width:150px; font-size:5rem;" />
              </div>
            </div>
          </el-col> -->

          <el-col :span="10" class="card">
            <div class="card-body" v-loading="checkInLoading">
              <div class="card-title date-title">
                <span>{{days}}</span>{{month}}月&nbsp;{{week}}
                <el-button type="text" class="right sign-lead" @click="drawer = true"><svg-icon icon-class="crown" />签到光荣榜</el-button>
              </div>
              <div class="card-content date-content">
                <div class="continuous">
                  <p class="days">{{continuousSignDays}}</p>
                  <p style="margin-top: 0">已连续签到</p>
                  <p style="margin-bottom: 0"><el-button type="primary" size="small" :loading="checkLoading" :disabled="todayischeck==1" @click="userCheckIn">{{todayischeck==1?'今日已签':'立即签到'}}</el-button></p>
                  <el-steps :active="continuousSignDays>7?7:continuousSignDays" align-center>
                    <el-step title="1天" description="+1"></el-step>
                    <el-step title="2天" description="+1"></el-step>
                    <el-step title="3天" description="+2"></el-step>
                    <el-step title="4天" description="+3"></el-step>
                    <el-step title="5天" description="+4"></el-step>
                    <el-step title="6天" description="+4"></el-step>
                    <el-step title="7天" description="+5"></el-step>
                  </el-steps>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-row class="tcf-row" style="padding-top: 0; padding-bottom: 0;">
          <el-col :span="14" class="card">
            <div v-loading="fileNoticeLoading" class="card-body">
              <div class="card-title">
                文件通知
                <el-button type="text" class="right"><router-link to="/notice/file_notice_list">更多</router-link></el-button>
              </div>
              <div class="card-content">
                <ul class="notice-list">
                  <li v-for="notice in fileNoticeData">
                    <router-link :to="{path:'/notice/file_notice_detail/'+notice.id}">
                      <el-tooltip effect="dark" :content="`${notice.title}`" placement="top">
                        <div class="notice-title">
                          <el-tag type="danger" size="mini" v-if="notice.read==0">未读</el-tag>
                          <el-tag size="mini" v-if="notice.top==1">置顶</el-tag>
                          <span class="txt">{{notice.title}}</span>
                        </div>
                      </el-tooltip>
                      <div class="notice-dept">{{notice.deptName}}</div>
                      <div class="notice-time">{{notice.createTime.split('.')[0]}}</div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>

          <el-col :span="10" class="card">
            <div v-loading="noticeLoading" class="card-body">
              <div class="card-title">
                通知公告
                <el-button type="text" class="right"><router-link to="/notice/notice_list">更多</router-link></el-button>
              </div>
              <div class="card-content">
                <ul class="notice-list">
                  <li v-for="notice in noticeData">
                    <router-link :to="{path:'/notice/notice_detail/'+notice.notice_id}">
                      <el-tooltip effect="dark" :content="`【${notice.type_name}】${notice.notice_name}`" placement="top">
                        <div class="notice-title">
                          <el-tag type="danger" size="mini" v-if="notice.is_read==0" >未读</el-tag>
                          <el-tag size="mini" v-if="notice.istop==1">置顶</el-tag>
                          <span class="txt">【{{notice.type_name}}】{{notice.notice_name}}</span>
                        </div>
                      </el-tooltip>
                      <div class="notice-dept">{{notice.dept_name}}</div>
                      <div class="notice-time">{{notice.time}}</div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
          <el-col :span="24" class="card">
            <div class="card-body" v-loading="newsLoading">
              <div class="card-title">
                最新资讯
                <el-button type="text" class="right" ><router-link to="/news/news_list">更多</router-link></el-button>
              </div>
              <div class="card-content news-content">
                <el-row>
                  <el-col :span="12" class="news-left" v-if="newsData.length>0">
                    <router-link :to="{path:'/news/news_detail/'+newsData[0].newsid}">
                      <div class="news-img" :style="'background-image:url('+newsData[0].img_url+')'">
                      </div>
                      <div class="new-title">
                        {{newsData[0].title}}
                      </div>
                    </router-link>
                  </el-col>
                  <el-col :span="12" class="news-right">
                    <ul class="news-list">
                      <li v-for="(news,index) in newsData" v-if="index > 0">
                        <router-link :to="{path:'/news/news_detail/'+news.newsid}">
                          <i class="el-icon-share"/>
                          <span class="txt">{{news.title}}</span>
                        </router-link>
                      </li>
                    </ul>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>

          <!-- <el-col :span="24" class="card">
            <div class="card-body study-info" v-loading="studyLoading">
              <el-carousel v-if="studyBanner.length>0" class="study-banner" height="120px" :interval="5000" indicator-position="none">
                <el-carousel-item v-for="banner in studyBanner">
                  <div class="banner-item" :style="'background-image:url('+banner.img_url+');cursor: pointer'" @click="goUrl(banner)"></div>
                </el-carousel-item>
              </el-carousel>
              <div class="card-title" :style="studyBanner.length>0?'margin-top: 20px;':''">
                {{ishaveStudy?'最近学习课程':'最新课程'}}
                <el-button v-if="!ishaveStudy" type="text" class="right" ><router-link to="/study/course">更多</router-link></el-button>
              </div>
              <div class="card-content">
                <ul class="course-list" v-if="ishaveStudy">
                  <li v-for="course in courseData" @click="goCourse(course.course_id,course.chapter_id)">
                    <div class="course-img" :style="'background-image:url('+course.img_url+')'"></div>
                    <div class="course-info">
                      <div class="course-name">{{course.course_name}}</div>
                      <div class="course-chapter">{{course.chapter_name}}</div>
                      <div class="course-cache">学习至{{course.percent}}%</div>
                    </div>
                  </li>
                </ul>
                <ul class="course-list" v-if="!ishaveStudy">
                  <li v-for="course in courseData" @click="goCourse(course.cid,0)">
                    <div class="course-img" :style="'background-image:url('+course.img_url+')'"></div>
                    <div class="course-info">
                      <div class="course-name">{{course.cname}}</div>
                      <div class="course-chapter">{{course.two_name}} / {{course.three_name}}</div>
                      <div class="course-cache">共 {{course.chapter_num}} 章节</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </el-col> -->
        </el-row>
      </el-col>
    </el-row>
    <el-drawer
      :with-header="false"
      :append-to-body="true"
      :visible.sync="drawer"
      :direction="direction"
      size="360px"
      custom-class="checkRank-drawer"
      :before-close="handleClose">
      <div class="checkRank-container">
        <div class="checkRank-header">签到光荣榜·TOP50</div>
        <div class="checkRank-main">
          <div class="checkRank-list">
            <div class="checkRank-item" v-for="(rank,index) in checkInRank">
              <div class="rank l">{{index+1}}</div>
              <div class="photo l"><el-avatar shape="square" fit="cover" :size="50" :src="rank.img_url"/></div>
              <div class="info l">
                <div class="name">{{rank.user_name}}</div>
<!--                <div class="position">{{rank.role===0?rank.dept_name+'/'+rank.position_name:rank.dept_name}}</div>-->
                <div class="position">{{rank.dept_name}}</div>
              </div>
              <div class="count r"><span>{{rank.total_check}}</span>次</div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getUserStudyTask, getUserStudyList, getStudyBanner, getNewsPC, getNoticeList, getUserCheckDetail, userCheckIn, getUserTodoList } from '@/api/home'
import { getDealerTodoList } from '@/api/dealer'
import { getCourseList } from '@/api/study/course'
import { getFileNotice } from '@/api/archive'

import men from '@/assets/photo_men.jpg'
import women from '@/assets/photo_women.jpg'

export default {
  name: 'index',
  computed: {
    user: getUser
  },
  data() {
    return {
      men: men,
      women: women,
      direction: 'rtl',
      drawer: false,
      days: '1',
      month: '1',
      week: '星期一',
      todoLoading: false,
      todoBadge: true,
      todoCount: 0,
      todoData: [], // 待办事项数据 mark:0 正常   1即将逾期   2已逾期
      toLearnLoading: false,
      toLearnBadge: true,
      toLearnCount: 0,
      todoPageSize: 5,
      todoCurrentPage: 1,
      toLearnData: [], // 待完成学习数据 mark:0 正常   1即将逾期   2已逾期
      noticeLoading: false,
      noticeData: [],
      fileNoticeLoading: false,
      fileNoticeData: [],
      newsLoading: false,
      newsData: [],
      studyLoading: false,
      studyBanner: [],
      courseData: {},
      checkInLoading: false,
      todayischeck: 0,
      checkLoading: false,
      continuousSignDays: 0,
      checkInRank: [],
      ishaveStudy: false
    }
  },
  created() {
    const date = new Date()
    this.days = date.getDate()
    this.month = date.getMonth() + 1
    this.week = '星期' + '日一二三四五六'.charAt(date.getDay())
    this.getUserCheckDetail()
    this.getTodoData()
    this.getNewsData()
    this.getNoticeData()
    this.getFileNoticeData()
    // this.getStudyData()
    // this.getToLearnData() // 待完成学习任务
  },
  watch: {
    $route(to, from) {
      if (to.path === '/index') {
        // this.getStudyData()
        // this.getToLearnData()
        this.getTodoData()
        this.getNoticeData()
        this.getNewsData()
        this.getUserCheckDetail()
        this.getFileNoticeData()
      }
    }
  },
  methods: {
    goTodo(todo) {
      if (todo.type === 0) { // 订单类型
        if (this.user.rank === 1) {
          this.$router.push({ path: '/work/delorder/' + todo.id })
        } else {
          this.$router.push({ path: '/work/order/' + todo.id })
        }
      } else if (todo.type === 1) { // 招商待打款
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/khgl' })
        } else {
          this.$router.push({ path: '/work/delrylb' }) // 人员列表
        }
      } else if (todo.type === 2) { // 方案排期
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/fapq' })
        } else {
          this.$router.push({ path: '/work/delwlsq' }) // 物料申请
        }
      } else if (todo.type === 3) { // 方案指派
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/fazp' })
        } else {
          this.$router.push({ path: '/work/delshhf' }) // 售后回访
        }
      } else if (todo.type === 4) { // 售后处理
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/shcl' })
        }
      } else if (todo.type === 5) { // 收款申请
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/sksq' })
        }
      } else if (todo.type === 6) { // 收款审核
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/sksh' })
        }
      } else if (todo.type === 7) { // 招商收款
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/zssk' })
        }
      } else if (todo.type === 8) { // 售后赔款
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/shpk' })
        }
      } else if (todo.type === 9) { // 人员分配
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/ryfp' })
        }
      } else if (todo.type === 10) { // 物料预警
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/wlyj' })
        }
      } else if (todo.type === 11) { // 出库
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/ck' })
        }
      } else if (todo.type === 12) { // 业绩支票返点
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/yjzpfdzh' })
        }
      } else if (todo.type === 13) { // 售后赔款
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/shpkzh' })
        }
      } else if (todo.type === 14) { // 报备金
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/bbjzh' })
        }
      } else if (todo.type === 15) { // 业绩支票返点审核
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/yjzpfdsh' })
        }
      } else if (todo.type === 16) { // 售后赔款审核
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/shpksh' })
        }
      } else if (todo.type === 17) { // 报备金审核
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/bbjsh' })
        }
      } else if (todo.type === 18) { // 物料申请
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/wlsq' })
        }
      } else if (todo.type === 19) { // 物料申请处理
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/wlsqcl' })
        }
      } else if (todo.type === 20) { // 临时折扣审核
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/lszksh' })
        }
      } else if (todo.type === 21) { // 售后金额分解
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/shjefj' })
        }
      } else if (todo.type === 22) { // 物料申领处理
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/wlslcl' })
        }
      } else if (todo.type === 23) { // 项目管理
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/project_detail/' + todo.id.split('@elichain@')[0] })
        }
      } else if (todo.type === 24) { // 意向金审核（招商总监）
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/yxjsh' })
        }
      } else if (todo.type === 25) { // 意向金审核（财务）
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/yxjshcw' })
        }
      } else if (todo.type === 26) { // 退款审核（招商总监）
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/zstksh' })
        }
      } else if (todo.type === 27) { // 招商退款审核（财务）
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/zstkshcw' })
        }
      } else if (todo.type === 28) { // 样品预存款审核（招商总监）
        if (this.user.rank === 0) {
          this.$router.push({ path: '/work/jmjsh' })
        }
      }
    },
    refTodo() {
      this.todoCurrentPage = 1
      this.getTodoData()
    },
    todoHandleCurrentChange(val) {
      this.todoCurrentPage = val
      this.getTodoData()
    },
    getTodoData() { // 获取待办事项数据
      this.todoLoading = true
      if (this.user.rank === 1) { // 经销商用户
        const data = {
          delid: this.user.delid,
          userid: this.user.userid,
          limit: this.todoPageSize,
          page: this.todoCurrentPage
        }
        getDealerTodoList(data).then(response => {
          let todoData = []
          for (let d of response.data) {
            if (d.orderid !== 'delkgwl' && d.orderid !== 'delrylb' && d.orderid !== 'delwlsq' && d.orderid !== 'delshhf' && d.orderid !== 'delggd') {
              let name = d.ordernum
              if (d.produnum !== null && d.produnum !== '' && d.produnum !== undefined && d.produnum.indexOf('SZ') < 0) {
                name = d.produnum
              }
              if (d.mark === 1) {
                name += ' 待提交'
              } else if (d.mark === 7) {
                name += ' 待确认'
              } else if (d.mark === 9) {
                name += ' 待预付款'
              }
              todoData.push({ id: d.orderid, name: name, time: d.time, mark: 0, type: 0 }) // type:0订单类型
            } else {
              if (d.orderid === 'delrylb') {
                todoData.push({ id: d.orderid, name: d.ordernum + ' ' + d.produnum + ' 人员待审核', time: d.time, mark: 1, type: 1 }) // type:1人员审核
              }
              if (d.orderid === 'delwlsq') {
                todoData.push({ id: d.orderid, name: '物料单' + d.ordernum + ' 款项待结清', time: d.time, mark: 2, type: 2 }) // type:2物料申请
              }
              if (d.orderid === 'delshhf') {
                todoData.push({ id: d.ordernum, name: d.produnum + ' 售后待评价', time: d.time, mark: 1, type: 3 }) // type:3售后回访
              }
              if (d.orderid === 'delggd') {
                if (d.mark === 0) {
                  todoData.push({ id: d.ordernum, name: '更改单 ' + d.produnum + ' 待提交', time: d.time, mark: 2, type: 0 }) // type:0订单类型
                } else if (d.mark === 5) {
                  todoData.push({ id: d.ordernum, name: '更改单 ' + d.produnum + ' 待确认', time: d.time, mark: 1, type: 0 }) // type:0订单类型
                }
              }
              if (d.orderid === 'delkgwl') {
                if (d.mark === 0) {
                  todoData.push({ id: d.ordernum, name: '订单 ' + d.produnum + ' 客供物料待发货', time: d.time, mark: 2, type: 0 }) // type:0订单类型
                } else if (d.mark === 1) {
                  todoData.push({ id: d.ordernum, name: '订单 ' + d.produnum + ' 客供物料待接收', time: d.time, mark: 1, type: 0 }) // type:0订单类型
                }
              }
            }
          }
          this.todoData = todoData
          this.todoCount = response.total
          if (this.todoCount > 0) {
            this.todoBadge = false
          } else {
            this.todoBadge = true
          }
          this.todoLoading = false
        }).catch(() => {
          this.todoLoading = false
        })
      } else {
        const data = {
          groupid: this.user.dGroupid,
          userid: this.user.dUserid,
          role: this.user.role,
          limit: this.todoPageSize,
          page: this.todoCurrentPage
        }
        getUserTodoList(data).then(response => {
          this.todoData = response.data
          this.todoCount = response.total
          this.todoLoading = false
        }).catch(() => {
          this.todoLoading = false
        })
      }
    },
    getToLearnData() { // 获取待完成学习数据
      this.toLearnLoading = true
      const _this = this
      _this.toLearnLoading = false
      _this.toLearnBadge = false
      _this.toLearnCount = 0
      let _userid = 0
      if (_this.user.rank === 0) {
        _userid = _this.user.dUserid
      } else {
        _userid = _this.user.userid
      }
      const data = {
        userid: _userid,
        role: _this.user.rank,
        page: 1,
        limit: 5
      }
      getUserStudyTask(data).then(response => {
        _this.toLearnData = response.data
        _this.toLearnCount = response.total
      })
    },
    getNoticeData() { // 获取公告信息
      this.noticeLoading = true
      const _this = this
      let _userid = 0
      if (_this.user.rank === 0) {
        _userid = _this.user.dUserid
      } else {
        _userid = _this.user.userid
      }
      const data = {
        page: 1,
        limit: 5,
        userid: _userid,
        role: _this.user.rank,
        mark: 1
      }
      _this.noticeLoading = false
      getNoticeList(data).then(response => {
        _this.noticeData = response.data.list
      })
    },

    getFileNoticeData() { // 获取文件通知
      this.fileNoticeLoading = true
      const data = {
        page: 1,
        limit: 5,
        userId: this.user.dUserid|| this.user.userid || '',
        dealerId: this.user.delid || ''
      }
      this.fileNoticeLoading = false
      getFileNotice(data).then(response => {
        this.fileNoticeData = response.data.list || []
      })
    },

    getNewsData() { // 获取资讯
      this.newsLoading = true
      const _this = this
      const data = {
        page: 1,
        limit: 6
      }
      getNewsPC(data).then(response => {
        _this.newsLoading = false
        _this.newsData = response.data.list
      })
    },
    getStudyData() {
      this.studyLoading = true
      const _this = this
      let _userid = 0
      if (_this.user.rank === 0) {
        _userid = _this.user.dUserid
      } else {
        _userid = _this.user.userid
      }
      const data = {
        userid: _userid,
        role: _this.user.rank,
        page: 1,
        limit: 6
      }
      getStudyBanner().then(response => {
        _this.studyBanner = response.data
      })
      getUserStudyList(data).then(response => {
        _this.courseData = response.data
        if (_this.courseData.length > 0) {
          _this.studyLoading = false
          _this.ishaveStudy = true
        } else {
          getCourseList({ page: 1, limit: 6 }).then(response => {
            _this.courseData = response.data
            _this.studyLoading = false
          })
        }
      })
    },
    goUrl(banner) {
      if (banner.type === 0) { // URL
        if (banner.url !== 'javascript:void(0);') {
          window.open(banner.url)
        } else {
          return false
        }
      } else if (banner.type === 1) { // 课程
        this.$router.push({ path: `/study/course_detail/${banner.cid}` })
      }
    },
    userCheckIn() {
      if (!this.checkLoading) {
        this.checkLoading = true
        let _userid = 0
        if (this.user.rank === 0) {
          _userid = this.user.dUserid
        } else {
          _userid = this.user.userid
        }
        const data = {
          userid: _userid,
          role: this.user.rank
        }
        userCheckIn(data).then(response => {
          this.checkLoading = false
          this.todayischeck = 1
          if (response.status === '200') {
            this.$message({
              message: '签到成功，积分+' + response.data.integral,
              type: 'success'
            })
            this.getUserCheckDetail()
          }
          if (response.status === '202') {
            this.$message({
              message: response.msg,
              type: 'warning'
            })
            this.getUserCheckDetail()
          }
        })
      }
    },
    getUserCheckDetail() {
      this.checkInLoading = true
      const _this = this
      let _userid = 0
      if (_this.user.rank === 0) {
        _userid = _this.user.dUserid
      } else {
        _userid = _this.user.userid
      }
      const data = {
        userid: _userid,
        role: _this.user.rank
      }
      _this.checkInLoading = false
      getUserCheckDetail(data).then(response => {
        _this.todayischeck = response.data.todayischeck
        _this.continuousSignDays = response.data.continuousSignDays
        _this.checkInRank = response.data.checkInListVos
        for (let i = 0; i < _this.checkInRank.length; i++) {
          if ('' === _this.checkInRank[i].img_url) {
            if ('男' === _this.checkInRank[i].sex) {
              _this.checkInRank[i].img_url = _this.men
            } else {
              _this.checkInRank[i].img_url = _this.women
            }
          }
        }
      })
    },
    handleClose(done) {
      done()
    },
    goCourse(courseId, chapterId) {
      this.$router.push({ path: '/study/course_detail/' + courseId })
    }
  }
}
</script>

<style lang="scss" scoped>
.index-container {
  .tcf-row{
    margin-left: -10px;
    margin-right: -10px;
    .card{
      margin-bottom: 20px;
      padding-left: 10px;
      padding-right: 10px;
      .card-body{
        min-height: 340px;
        .date-title{
          font-weight: 400;
          span{
            color:#4385f7;
            font-size: 20px;
            margin: 0 6px;
          }
          .sign-lead{
            margin-top: -2px;
            font-size: 13px;
            padding: 0!important;
            color:#f3ad49;
            font-weight: 500;
            .svg-icon{
              vertical-align: -4px!important;
            }
          }
        }
        .date-content{
          text-align: center;
          .continuous{
            color:#999999;
            padding-top: 10px;
            .days{
              color:#4385f7;
              font-size: 40px;
              margin: 0 6px;
            }
          }
        }
        .card-content{
          .todo-list{
            width: 100%;
            padding: 0;
            margin: -5px 0 0 0;
            position: relative;
            li{
              list-style: none;
              position: relative;
              padding-top: 5px;
              padding-bottom: 5px;
              cursor: pointer;
              border-bottom: 1px solid #f5f7fa;
              padding-left: 30px;
              border-radius: 2px;
              i {
                position: absolute;
                left: 4px;
                top: 8px;
              }
              &:last-child{
                border-bottom: 0;
              }
              &:hover{
                background: #f5f7fa;
                .todo-name{
                  color: #409EFF;
                }
              }
              .el-tag{
                position: absolute;
                right: 4px;
                top: 5px;
              }
              .todo-name{
                width: 100%;
                position: relative;
                padding-right: 70px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                line-height: 20px;
              }
              .todo-warning{
                color: #E6A23C;
              }
              .todo-danger{
                color: #F56C6C;
              }
              .todo-time{
                font-size: 12px;
                color:#999999;
                line-height: 16px;
              }
            }
          }
          .tolearn-list{
            width: 100%;
            padding: 0;
            margin: -5px 0 0 0;
            position: relative;
            li{
              list-style: none;
              position: relative;
              padding-top: 5px;
              padding-bottom: 5px;
              cursor: pointer;
              border-bottom: 1px solid #f5f7fa;
              padding-left: 30px;
              border-radius: 2px;
              i {
                position: absolute;
                left: 4px;
                top: 8px;
              }
              &:hover{
                background: #f5f7fa;
                .tolearn-name{
                  color: #409EFF;
                }
              }
              &:last-child{
                border-bottom: 0;
              }
              .el-progress{
                position: absolute!important;
                right: 4px !important;
                top: 4px !important;
              }
              .el-button{
                position: absolute!important;
                right: 4px !important;
                top: 4px !important;
                color: #606266!important;
                background-color: #ffffff!important;
                border-color: #e5e9f2!important;
                border-width: 6px!important;
                width: 40px!important;
                height: 40px!important;
                padding: 6px!important;
              }
              .tolearn-name{
                width: 100%;
                position: relative;
                padding-right: 70px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                line-height: 20px;
              }
              .tolearn-warning{
                color: #E6A23C;
              }
              .tolearn-danger{
                color: #F56C6C;
              }
              .tolearn-time{
                font-size: 12px;
                color:#999999;
                line-height: 16px;
              }
            }
          }
          .notice-list{
            width: 100%;
            padding: 0;
            margin: -5px 0 0 0;
            position: relative;
            li{
              list-style: none;
              position: relative;
              padding-left: 4px;
              padding-top: 13px;
              padding-bottom: 13px;
              cursor: pointer;
              border-bottom: 1px solid #f5f7fa;
              border-radius: 2px;
              &:hover{
                background: #f5f7fa;
                .notice-title{
                  .txt{
                    color: #409EFF;
                  }
                }
              }
              &:last-child{
                border-bottom: 0;
              }
              .notice-title{
                width: 100%;
                position: relative;
                padding-right: 230px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                line-height: 20px;
              }
              .notice-dept{
                 width: 80px;
                 position: absolute;
                 right: 140px;
                 top:16px;
                 text-overflow: ellipsis;
                 overflow: hidden;
                 white-space: nowrap;
                color: #999999;
              }
              .notice-time{
                width: 130px;
                position: absolute;
                right: 4px;
                top:16px;
                color: #999999;
              }
            }
          }
        }
        .news-content{
          .news-left{
            box-sizing: border-box;
            position: relative;
            cursor: pointer;
            .news-img{
              border-radius: 2px;
              width: 100%;
              height: 180px;
              background-position: center center;
              background-size: cover;
              background-repeat: no-repeat;

            }
            .new-title{
              line-height: 18px;
              width: 100%;
              box-sizing: border-box;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              margin-top: 10px;
              text-align: center;
            }
            &:hover{
              .new-title{
                color:#409EFF;
              }
            }
          }
          .news-right{
            position: relative;
            padding-left: 20px;
            .news-list{
              width: 100%;
              padding: 0;
              margin: -5px 0 0 0;
              position: relative;
              li{
                list-style: none;
                position: relative;
                padding-left: 4px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-bottom: 1px solid #f5f7fa;
                border-radius: 2px;
                width: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                .el-icon-share{
                  color:#cbe2fc;
                }
                &:hover{
                  background: #f5f7fa;
                  .txt{
                    color: #409EFF;
                  }
                }
                &:last-child{
                  border-bottom: 0;
                }
              }
            }
          }
        }
      }
      .study-info{
        min-height: 680px;
        .study-banner{
          height: 120px;
          .banner-item{
            border-radius: 2px;
            width: 100%;
            height: 120px;
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;
          }
        }
        .card-content{
          .course-list{
            width: 100%;
            padding: 0;
            margin: -5px 0 0 0;
            position: relative;
            li{
              list-style: none;
              position: relative;
              padding-left: 95px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-bottom: 1px solid #f5f7fa;
              border-radius: 2px;
              .course-img{
                border-radius: 2px;
                width: 75px;
                height: 42px;
                background-position: center center;
                background-size: cover;
                background-repeat: no-repeat;
                position: absolute;
                top:15px;
                left: 10px;
              }
              .course-info{
                width: 100%;
                position: relative;
                height: 42px;
                .course-name{
                  width: 100%;
                  padding-right: 85px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                }
                .course-chapter{
                  font-size: 12px;
                  color:#999999;
                  padding-top: 6px;
                  width: 100%;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                }
                .course-cache{
                  position: absolute;
                  width: 80px;
                  line-height: 18px;
                  text-align: center;
                  font-size: 11px;
                  right: 0;
                  top:0;
                  background: #F4BF40;
                  color:#ffffff;
                  border-bottom-left-radius: 8px;
                }
              }
              &:hover{
                background: #f5f7fa;
                .course-name{
                  color: #409EFF;
                }
              }
              &:last-child{
                border-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
.checkRank-container{
  width: 100%;
  height: 100%;
  position: relative;
  .checkRank-header{
    width: 100%;
    height: 60px;
    line-height: 60px;
    position: absolute;
    text-align: center;
    top: 0;
    left: 0;
    font-size: 18px;
    background: #ffffff;
    z-index: 1;
  }
  .checkRank-main{
    width: 100%;
    height: 100%;
    position: relative;
    padding-top: 60px;
    overflow:auto;
    .checkRank-list{
      width: 100%;
      height: 100%;
      padding: 0 30px;
      .checkRank-item{
        width: 100%;
        height: 56px;
        margin:20px 0;
        .rank{
          width: 30px;
          line-height: 56px;
          font-size: 18px;
          font-weight: bold;
          font-style: oblique;
          color:#606266;
        }
        .info{
          padding-left: 10px;
          .name{
            font-weight: 500;
            margin-top: 3px;
            margin-bottom: 4px;
            font-size: 13px;
          }
          .position{
            color: #c2c2c2;
            font-size: 12px;
            font-weight: 400;
          }
        }
        .count{
          font-size: 12px;
          padding-top: 10px;
          span{
            font-size: 14px;
            font-weight: bold;
            color:#409EFF;
            margin-right: 4px;
          }
        }
        .l{
          float: left;
        }
        .r{
          float: right;
        }
      }
    }
  }
}
</style>
